import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, message, Modal as AntdModal,  } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { exportFile } from '../../utils/common'
import store from "../../store";
import Modal from "@mui/material/Modal";
import LabelModal from "../common/LabelModal";
import MuiAlert from "@mui/material/Alert";
const { RangePicker } = DatePicker;
const { Option } = Select;
const { confirm } = AntdModal;

import { 
  mixsearch,
  getFileStatusList,
  delelteFileLabel,
  getUserInfo,
  addLabelToFile,
  collectFile,
  cancelCollectFile,
  addCollectLabel,
} from '../../actions/subscribe'

import {
  getLabelId,
  getCollectId,
} from "../../utils/common";

const styles = () => {
  return {
    root: {
      width: "100%",
      padding: "16px",
      background: "#fff"
    },
    search: {
      width: "100%",
      padding: "16px 0",
      display: "flex",
      justifyContent: "space-between",
      background: "#fff",
      borderBottom: "1px solid #ddd"
    },
    formBox: {
      flex: '1',
      display: "flex",
      flexWrap: "wrap"
    },
    formItem: {
      display: "flex",
      alignItems: "center",
      width: "300px",
      height: "34px",
      marginBottom: "12px",
      paddingRight: "30px", 
    },
    label: {
      width: "110px",
      textAlign: "right",
      paddingRight: "10px"
    },
    input: {
      flex: "1",
      width: "100%",
      "& input, & .ant-select": {
        width: "100%",
        height: "34px",
        '& .ant-select-selector': {
          height: "34px",
          '& .ant-select-selection-search': {
            '& input': {
              height: '32px',
              lineHeight: '32px'
            }
          },
          '& .ant-select-selection-placeholder': {
            lineHeight: '32px'
          }
        }
      },
      '& button': {
        width: "100px",
        height: "34px"
      }
    },
    descBox: {
      width: "380px",
      padding: "10px",
      background: "#f9edbe",
      border: "1px solid #edca89",
      color: "#a96b29",
      fontSize: "14px",
      lineHeight: "18px"
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },
    container: {
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
  };
};

class CompositeSearch extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    openModal: false,
    openMessage: false,
    tagArr: [],
    collectLabelId: [],
    errorMessage: '',
    dataId: '',
    columns: [],
    statusList: [],
    username: '',
    userId: '',
    collectFileId: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    searchList: [
      {
        ID: '',
        Name: '精确搜索'
      },
      {
        ID: 'es',
        Name: '模糊搜索'
      },
    ],
    form: {
      status: [],
      searchType: '',
      keyword: '',
    },
    defaultForm: { // 默认值
      status: [],
      searchType: '',
      keyword: '',
    },
    labelObj: { // 筛选项key - label对应关系
      status: '状态',
      searchType: '搜索类型',
      keyword: '关键词',
    },
    labelListObj: { 
      status: 'statusList',
      searchType: 'searchList',
    },
    selectKeys: ['status', 'searchType'],
    page: {
      page: 1,
      pageSize: 10
    },
    scroll: {
      y: 560
    },
    tabIndex: 1,
    tabList: [
      '标准', '法律行政法规', '指导原则'
    ],
    total: 0,
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      pageSizeOptions: [10, 20, 30, 50, 100],
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条数据'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    },
  };

  componentDidMount() {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    this.initData()
    this.initParam()

    this.setState({
      username: store.getState().auth.username
    }, () => this.queryUserInfo())

    // let height = document.body.offsetHeight
    // this.setState({
    //   scroll: {
    //     y: height - 355
    //   }
    // })
  }

  resetForm = () => {
    this.setState({
      form: {
        status: [],
        searchType: '',
        keyword: '',
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (key === 'searchType' || (form[key] && form[key].length > 0)) {
        let showValue = form[key]
        let label = ''
        if (key === 'status') {
          label = form[key].join()
        }
        if (key === 'searchType') {
          label = form[key] ? '模糊搜索' : '精确搜索'
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initParam = () => {
    getFileStatusList().then(res => {
      this.setState({
        statusList: res.fileStatus
      })
    })
  }

  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results[0];
        if (userData) {
          this.setState({
            userId: userData.id,
            collectFileId: userData.favorite_basefiles.map((v) => {
              return v.basefile_id;
            }),
            collectLabelId: userData.favorite_lables.map((v) => {
              return v.lable_id;
            }),
          }, () => this.getColumns());
        }
      }
    });
  };

  getColumns = () => {
    let columns = [
      {
        title: '状态',
        dataIndex: 'medical_file_law_status',
        key: 'medical_file_law_status',
        align: 'center',
        width: '160px'
      },
      {
        title: '编号',
        dataIndex: 'file_number',
        key: 'file_number',
        align: 'center',
        width: '180px'
      },
      {
        title: '名称',
        dataIndex: 'ProductName',
        key: 'ProductName',
        align: 'center',
        render: (_, record) => (
          <a onClick={e => this.previewFile(record.base_file.dfs_url)} title={record.base_file.file_name}>{record.base_file.file_name.length > 20 ? `${record.base_file.file_name.substring(0, 20)}...` : record.base_file.file_name}</a>
        )
      },
      {
        title: '发布日期',
        dataIndex: 'medical_file_publish_date',
        key: 'medical_file_publish_date',
        align: 'center',
        render: (_, record) => {
          if (record.medical_file_publish_date) {
            return record.medical_file_publish_date.substring(0, 10)
          } else {
            return ''
          }
        },
      },
      {
        title: '实施日期',
        dataIndex: 'medical_file_force_date',
        key: 'medical_file_force_date',
        align: 'center',
        render: (_, record) => {
          if (record.medical_file_force_date) {
            return record.medical_file_force_date.substring(0, 10)
          } else {
            return ''
          }
        },
      },
      {
        title: '截止日期',
        dataIndex: 'medical_file_expired_date',
        key: 'medical_file_expired_date',
        align: 'center',
        render: (_, record) => {
          if (record.medical_file_expired_date) {
            return record.medical_file_expired_date.substring(0, 10)
          } else {
            return ''
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        key: 'action',
        width: '140px',
        render: (_, record) => (
          <>
            <a
              onClick={() => this.downloadFile(record)}
            >
              下载
            </a>
            &nbsp;&nbsp;
            {
              this.state.collectFileId.includes(
                record.base_file.file_id
              ) ?
              <a
                onClick={() => this.handCancelCollect(record.base_file.file_id)}
              >
                取消收藏
              </a>
              :
              <a
                onClick={() => this.handCollect(record.base_file.file_id)}
              >
                收藏
              </a>
            }
          </>
        )
      },
    ]
    this.setState({
      columns: columns
    })
  }

  initData = () => {
    let param =  Object.assign({
      fileType: this.state.tabIndex == 1 ? '标准' : (this.state.tabIndex == 2 ? '法规' : '指导原则')
    }, {
      ...this.state.form,
      searchStatus: this.state.form.status.join()
    }, this.state.page)
    delete (param.status)
    mixsearch(param).then(res => {
      if (res.results) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        this.setState({
          data: res.results.map(v => {
            v.key = v.id
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => this.getColumns())
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }




  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  handleChange = (e, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = e.target.value
    this.setState({
      form: form
    })
  }

  onChangeTab = (e) => {
    this.setState({
      tabIndex: e,
      loading: true
    }, () => this.initData())
  }

  handleSearch = () => {
    this.initData()
  }

  downloadFile = (data) => {
    let url = data.base_file.dfs_url
    let fileName = data.base_file.file_name
    exportFile(url, fileName)
  }

  previewFile = url => {
    let a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  handleClose = () => {
    this.setState({
      openModal: false
    })
  }
  
  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };
  
   //收藏文件
   handAdd = (tag) => {
    //检查是否已存在
    let index = this.state.tagArr.findIndex((v) => {
      return v.lable_content == tag;
    });
    if (index > -1) {
      this.setState({
        openMessage: true,
        errorMessage: "该标签已存在",
      });
      setTimeout(() => {
        this.closeMessage();
      }, 3000);
      return;
    }
    //获取标签id
    getLabelId(tag, this.state.userId).then((labelId) => {
      //打标签
      addLabelToFile({
        base_file: this.state.dataId,
        lable: labelId,
        lable_update_user: this.state.userId,
      }).then((resp) => {
        if (resp.id) {
          this.setState({
            tagArr: this.state.tagArr.concat([
              {
                lable_content: tag,
                lable_id: labelId,
              },
            ]),
          });
        }
      });

      //收藏标签
      if (this.state.collectLabelId.includes(labelId) == false) {
        addCollectLabel({
          lable: labelId,
          user: this.state.userId,
        });
      }
    });
  };

  handRemove = (id) => {
    delelteFileLabel(id);
    let tagArr = [].concat(this.state.tagArr);
    let index = tagArr.findIndex((v) => {
      return v.lable_id === id;
    });
    tagArr.splice(index, 1);
    this.setState({
      tagArr: [].concat(tagArr),
    });
  };

  // 打开收藏文件弹框
  handCollect = (id) => {
    this.setState({
      openModal: true,
      dataId: id,
      tagArr: [],
    });
    //收藏文件
    collectFile({
      base_file: id,
      user: this.state.userId,
    }).then(res => {
      this.queryUserInfo()
    });
  };
  //取消收藏
  handCancelCollect = (id) => {
    confirm({
      title: '确认',
      content: '确认取消收藏？',
      onOk: () => {
        getCollectId(id, this.state.userId).then((collectId) => {
          cancelCollectFile(collectId).then((res) => {
            if (res && res.message) {
              message.warning(res.message)
            } else {
              message.success('取消成功')
              this.queryUserInfo();
            }
          });
        });
      }
    })
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">状态</div>
              <Select
                allowClear
                className={classes.select}
                mode="multiple"
                placeholder="请选择"
                value={this.state.form.status}
                onChange={(e) => this.onChangeForm(e, 'status')} 
              >
                {
                  this.state.statusList.map((v, i) => {
                    return (
                      <Option value={v} key={i}>{v}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">搜索类型</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.searchType}
                onChange={(e) => this.onChangeForm(e, 'searchType')} 
              >
                {
                  this.state.searchList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>

            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.keyword}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                placeholder="请输入名称或编号"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">综合搜索</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <div className="main-top">
              <div>
                {
                  this.state.tabList.map((v, i) => (
                    <span
                     key={i}
                     onClick={() => this.onChangeTab(i + 1)}
                     className={[
                       "main-tab",
                       this.state.tabIndex == i + 1 ? "active" : "",
                     ].join(" ")}
                    >
                      {v}
                    </span>
                  ))
                }
              </div>
            </div>
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>


        <Modal
          open={this.state.openModal}
          onClose={this.handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <LabelModal
              width={520}
              title="文件收藏"
              close={this.handleClose}
              tagArr={this.state.tagArr}
              handAdd={this.handAdd}
              handRemove={this.handRemove}
              dataId={this.state.dataId}
             
            />
          </div>
        </Modal>


        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.openMessage}
          onClose={this.closeMessage}
        >
          <MuiAlert elevation={6} variant="filled" severity="warning">
            {this.state.errorMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(CompositeSearch));
